import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { TimelineLabelType, DashboardTimelineType } from '../../../constants/ComponentTypes';
import classNames from 'classnames';

const styles = () => ({
  root: {
    fontSize: '13px',
    fontWeight: 'bold',
    borderRadius: '2px',
    padding: '7px 15px',
  },

  approach: {
    background: '#F2F6FF',
    color: '#1A65FF',
  },

  appointment: {
    background: '#E7FAEF',
    color: '#3D8D5F',
  },

  close: {
    background: '#FFF3C6',
    color: '#D6B330',
  },

  approachNg: {
    background: '#FFF2F2',
    color: '#FF606C',
  },

  default: {
    background: '#F2F6FF',
    color: '#1A65FF',
  },
});

class StatusLabel extends React.Component {
  render() {
    const { classes, type, style } = this.props;

    let text, color;
    switch (type) {
      // 注文受付・校了データ作成・印刷中・発送済みもアプローチ開始に含める
      case TimelineLabelType.APPROACH.value:
      case TimelineLabelType.PROOFREAD_CREATED.value:
      case TimelineLabelType.ORDER_PRINTING.value:
      case TimelineLabelType.ORDER_SHIPPED.value:
        text = DashboardTimelineType.APPROACH.text;
        color = classes.approach;
        break;
      // 商談成立
      case TimelineLabelType.APPOINTMENT.value:
        text = TimelineLabelType.APPOINTMENT.text;
        color = classes.appointment;
        break;
      // クローズ
      case TimelineLabelType.CLOSE.value:
        text = TimelineLabelType.CLOSE.text;
        color = classes.close;
        break;
      // アプローチNG
      case TimelineLabelType.APPROACH_NG.value:
        text = TimelineLabelType.APPROACH_NG.text;
        color = classes.approachNg;
        break;
      // その他
      default: {
        const target = Object.values(TimelineLabelType).find(label => label.value === type);
        if (target) {
          text = target.text;
        }
        color = classes.default;
        break;
      }
    }

    return (
      <div className={classNames(classes.root, color)} style={style}>
        {text}
      </div>
    )
  }
}

StatusLabel.propTypes = {
  classes: PropTypes.object.isRequired,
  type: PropTypes.number,
  style: PropTypes.object,
};

export default withStyles(styles)(StatusLabel);



// WEBPACK FOOTER //
// ./src/components/Timeline/parts/StatusLabel.jsx